const UnLoadScripts = (callback) => {
  const existingScript = document.getElementById("clinicaltables");
  if (existingScript) {
    existingScript.remove();
  }
};
export default UnLoadScripts;
